import React from 'react';
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmDialog = (props) => {
    const { title, children, confirmOpen, setConfirmOpen, onConfirm } = props;
    
    const handleCancel = () => {
        setConfirmOpen(false);
    };
    
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        setConfirmOpen(false);
    };
    
    return (
        <Dialog
            open={confirmOpen}
            onClose={handleCancel}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title">{title || 'Confirm'}</DialogTitle>
            <DialogContent>
                {typeof children === 'string' ? (
                    <DialogContentText id="confirm-dialog-description">
                        {children}
                    </DialogContentText>
                ) : (
                    children
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    autoFocus
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default ConfirmDialog;